module.exports = __webpack_public_path__ + "img/kefuCode.8b10454e.png";